import {setNewBuyAutofill} from "../../../../../_reducers/DataPanel/Buys/buysSlice";
import {openTabByType} from "../../../../../_helpers/tabOpeners";
import axios from "axios";
import {toast} from "react-toastify";

export const formatDeliveryStatus = (myDataStatus) => {
    if (myDataStatus === 0) return "Έχει εκδοθεί Δ.Α.";
    else if (myDataStatus === 1) return "Έχει ξεκινήσει από μεταφορέα";
    else if (myDataStatus === 2) return "Παράδοση από μεταφορέα";
    else if (myDataStatus === 3) return "Ολοκληρωμένη";
    else if (myDataStatus === 4) return "Απόρριψη από λήπτη";
    else if (myDataStatus === 5) return "Ακύρωση από εκδότη";
    else if (myDataStatus === 6) return "Αποτυχία παράδοσης";
    else if (myDataStatus === 7) return "Έχει ξεκινήσει από μεταφορέα η επιστροφή";
    else if (myDataStatus === 8) return "Ολοκληρωμένη - Επιστροφή";
    else return myDataStatus;
}

export const formatDeliveryStatusColor = (myDataStatus) => {
    if ([0, 1, 2, 7].includes(myDataStatus)) return "#badcf5";
    else if ([3, 8].includes(myDataStatus)) return "#c6f3da";
    else if ([4, 5, 6].includes(myDataStatus)) return "#f6cac5";
    else return "";
}

export const formatTransferEvent = (ev) => {
    if (ev === "RegisterTransfer") return "Έναρξη μεταφοράς/Μεταφόρτωση";
    else if (ev === "ConfirmOutcome") return "Δήλωση Αποτελέσματος";
    else if (ev === "Rejection") return "Ολική απόρριψη";
    else if (ev === "RegisterTransferReturn") return "Έναρξη μεταφοράς/Μεταφόρτωση - Επιστροφή";
    else if (ev === "ConfirmDeliveryReturn") return "Ολοκλήρωση Επιστροφής";
    else return ev;
}

export const outcomeOptions = [
    {value: "NONE", label: "Αποτυχία παράδοσης"},
    {value: "PARTIAL", label: "Μερική παράδοση"},
    {value: "FULL", label: "Πλήρης παράδοση"},
];

export const outComeOptionsNoPartial = outcomeOptions.filter((el) => el.value !== "PARTIAL");

export const getCommonEntityAcrossAll = (documents) => {
    try {
        if (!documents || documents.length === 0) return null;
        const firstDocEntities = documents[0]?.otherCorrelatedEntities || [];

        return firstDocEntities.find((candidate) => {
            return documents.slice(1).every((doc) => {
                const entities = doc.otherCorrelatedEntities || [];
                return entities.some((e) => e.type === candidate.type && e.vatNumber === candidate.vatNumber && e.type === "3");
            });
        }) || null;
    } catch {}
    return null;
}

export const transferStatusOptions = [
    {label: "Έχει εκδοθεί Δ.Α.", value: 0},
    {label: "Έχει ξεκινήσει από μεταφορέα", value: 1},
    {label: "Παράδοση από μεταφορέα", value: 2},
    {label: "Ολοκληρωμένη", value: 3},
    {label: "Απόρριψη από λήπτη", value: 4},
    {label: "Ακύρωση από εκδότη", value: 5},
    {label: "Αποτυχία παράδοσης", value: 6}
]

export const to10dot1 = (selectedRows, advancedTypesBuys, TABS_DATA, company, setLoading) => {
    return (dispatch) => {
        setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/sale/transfer-onboard-10-dot-1`, {
            company: company.id,
            supplierVATNumber: selectedRows[0].issuerVatNumber,
        }).then((res) => {
            if (res.data.status === "200") {
                const advDoc = res.data.advancedDocument;
                dispatch(setNewBuyAutofill({
                    documentType: advDoc._id,
                    documentTypeName: advDoc.name,

                    supplier: res.data.supplier,
                    otherCorrelatedInvoices: selectedRows.map((inv) => {
                        return {
                            docId: "",
                            docMark: String(inv.invoiceMark),
                            docMyDataType: "",
                            docInfo: inv.documentLabel,
                            docNotes: "",
                        }
                    })
                }));
                dispatch(openTabByType("buys-new", TABS_DATA));
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setLoading(false);
        });
    }
}

export const transferIsPartial = (tObj) => tObj?.lifecycleHistory?.some((el) => el.outcome === "PARTIAL");
export const isTransferTransporter = (tObj, vatNumber) => {
    return tObj?.lifecycleHistory?.some((el) => el.eventType === "RegisterTransfer"
        && (el.actorVat === vatNumber || el.carrierVatNumber === vatNumber));
}
export const isTransferIssuer = (tObj, vatNumber) => tObj.issuerVatNumber === vatNumber;

